'use client';
import Image from 'next/image';
import Link from 'next/link';

const PartnersSection = () => {

  const Partners  = [
    {
      alt: "globalblockchainshow",
      src: "/images/mediapartnerlogo/globalblockchainshow-white.svg",
      link: "https://www.globalblockchainshow.com/",
    },
    {
      alt: "global-games-show",
      src: "/images/mediapartnerlogo/global-games-show.svg",
      link: "https://www.globalgamesshow.com/",
    },
  ];


  const mediaPartners = [

    /*     {
      alt: "all-conference-alert",
      src: "/images/mediapartnerlogo/all-conference-alert.webp",
      link: "https://allconferencealert.net/",
    },
    {
      alt: "CapitalBay-News",
      src: "/images/mediapartnerlogo/capitalbay-newslogo.svg",
      link: "https://www.capitalbay.news/",
    },
    {
      alt: "CryptoJist",
      src: "/images/mediapartnerlogo/cryptojist.webp",
      link: "https://cryptojist.com/",
    },
    {
      alt: "gtm-labs-icon",
      src: "/images/mediapartnerlogo/gtm-labs-icon.webp",
      link: "https://gtmlabs.xyz/",
    },
    {
      alt: "coin-gabbar",
      src: "/images/mediapartnerlogo/coin-gabbar.webp",
      link: "http://www.coingabbar.com/",
    },
    {
      alt: "aitimejournal",
      src: "/images/mediapartnerlogo/aitimejournal-w.webp",
      link: "https://www.aitimejournal.com/",
    },
    {
      alt: "CoinNewspan",
      src: "/images/mediapartnerlogo/coinnewsspan-white.webp",
      link: "https://www.coinnewsspan.com/",
    },
    {
      alt: "CryptoMoonPress",
      src: "/images/mediapartnerlogo/cryptomoonpress-.webp",
      link: "https://cryptomoonpress.com",
    },
    {
      alt: "CryptoNewsZ",
      src: "/images/mediapartnerlogo/cryptonewsz.webp",
      link: "https://www.cryptonewsz.com/",
    },
    {
      alt: "Cryptopolitan",
      src: "/images/mediapartnerlogo/cryptopolitan.webp",
      link: "https://www.cryptopolitan.com/",
    },
    {
      alt: "NameCoinNews",
      src: "/images/mediapartnerlogo/namecoinnews.webp",
      link: "https://www.namecoinnews.com",
    },
    {
      alt: "times-of-AI",
      src: "/images/mediapartnerlogo/timesofai.webp",
      link: "https://www.timesofai.com/",
    },
    {
      alt: "Times-of-Blockchain",
      src: "/images/mediapartnerlogo/timesofblockchain.webp",
      link: "https://www.timesofblockchain.com/",
    },
    {
      alt: "3Verse-TV",
      src: "/images/mediapartnerlogo/3versetv.webp",
      link: "https://www.3versetv.com/",
    },
    {
      alt: "Coingape",
      src: "/images/mediapartnerlogo/coingape.webp",
      link: "https://www.coingape.com/",
    },
    {
      alt: "Crypto-news",
      src: "/images/mediapartnerlogo/cryptonews.webp",
      link: "https://crypto.news/",
    },
     {
      alt: "CoinpediaFintech",
      src: "/images/mediapartnerlogo/coinpediafintech.webp",
      link: "https://coinpedia.org/",
    },
     {
      alt: "Bitcoinworld",
      src: "/images/mediapartnerlogo/bitcoinworld.webp",
      link: "https://bitcoinworld.co.in/",
    },
    {
      alt: "Voice-of-Crypto",
      src: "/images/mediapartnerlogo/voiceofcrytpo.webp",
      link: "https://voiceofcrypto.online/",
    },
    {
      alt: "Coin-Roop",
      src: "/images/mediapartnerlogo/coinroop.webp",
      link: "https://coinroop.com/",
    },
     {
      alt: "Coinworldstroy",
      src: "/images/mediapartnerlogo/coinworldstory.webp",
      link: "https://coinworldstory.com/",
    },
     {
      alt: "Bitcoin-Insider",
      src: "/images/mediapartnerlogo/bitcoininsider-logo-condensed-white.webp",
      link: "https://www.bitcoininsider.org/",
    },
     {
      alt: "Cryptoken-Media",
      src: "/images/mediapartnerlogo/cryptotkonmedia.webp",
      link: "https://cryptoken.media",
    },
    {
      alt: "CryptoBrowser",
      src: "/images/mediapartnerlogo/cryptobrowser.webp",
      link: "https://cryptobrowser.io/",
    },
     {
      alt: "CoinTopper",
      src: "/images/mediapartnerlogo/cointopper-new.webp",
      link: "https://cointopper.com/",
    },
     {
      alt: "CoinsCapture",
      src: "/images/mediapartnerlogo/coinscapture.webp",
      link: "https://coinscapture.com/",
    },
       {
      alt: "The-Blockopedia",
      src: "/images/mediapartnerlogo/theblockopedia-new.webp",
      link: "https://theblockopedia.com/",
    },
       {
      alt: "Coinfea",
      src: "/images/mediapartnerlogo/coinfea.webp",
      link: "https://coinfea.com/",
    },
       {
      alt: "Tok-Times",
      src: "/images/mediapartnerlogo/toktimes.webp",
      link: "https://toktimes.com/",
    },
      {
      alt: "International-Business-Magazine",
      src: "/images/mediapartnerlogo/iib.webp",
      link: "https://intlbm.com/",
    },
      {
      alt: "Ed-Arabia",
      src: "/images/mediapartnerlogo/edarabia-logo.webp",
      link: "https://www.edarabia.com/",
    },
      {
      alt: "Dubai-Global-News",
      src: "/images/mediapartnerlogo/dgn.webp",
      link: "https://www.dubaiglobalnews.com/",
    },
      {
      alt: "ZEX-PR-WIRE",
      src: "/images/mediapartnerlogo/zex-pr-wire.webp",
      link: "https://zexprwire.com/",
    },
      {
      alt: "Key-Wire",
      src: "/images/mediapartnerlogo/kd-wire.webp",
      link: "https://keydifference.com/wire/",
    },
      {
      alt: "Brand-PR",
      src: "/images/mediapartnerlogo/brandpr.webp",
      link: "https://brandpr.io/",
    },
      {
      alt: "StartupNews.fyi",
      src: "/images/mediapartnerlogo/startup.webp",
      link: "https://startupnews.fyi/",
    },  {
      alt: "Financial Services Review",
      src: "/images/mediapartnerlogo/financial.webp",
      link: "https://www.financialservicesreview.com/",
    },   
    {
      alt: "Smart-Money-Match",
      src: "/images/mediapartnerlogo/smart-money-match.webp",
      link: "https://www.smartmoneymatch.com/help/media-partnerships",
    },  {
      alt: "Transport-Stake",
      src: "/images/mediapartnerlogo/transport-stake-logo.webp",
      link: "https://www.transportstake.com/",
    },
     {
      alt: "Publicity-Marketplace",
      src: "/images/mediapartnerlogo/publicity-marketplace.webp",
      link: "https://www.publicitymarketplace.com/",
    },
     {
      alt: "Functional-Sourcing",
      src: "/images/mediapartnerlogo/functionalsourcing.webp",
      link: "https://www.functionalsourcing.com/",
    },
     {
      alt: "Education-Stake",
      src: "/images/mediapartnerlogo/education-stake-logo.webp",
      link: "https://www.educationstake.com/",
    },
     {
      alt: "MatchSDG",
      src: "/images/mediapartnerlogo/match-sdg-logo.webp",
      link: "https://www.matchsdg.com/",
    },
     {
      alt: "Huidu",
      src: "/images/mediapartnerlogo/huidui.io.webp",
      link: "#",
    },
     {
      alt: "DroomDroom",
      src: "/images/mediapartnerlogo/droomdroom-logo.webp",
      link: "https://droomdroom.com/",
    },
        {
      alt: "alhuda",
      src: "/images/mediapartnerlogo/alhuda.webp",
      link: "https://www.alhudacibe.com/",
    },
        {
      alt: "Listing.Help",
      src: "/images/mediapartnerlogo/listing-help.webp",
      link: "https://listing.help/",
    },
        {
      alt: "Corum8",
      src: "/images/mediapartnerlogo/corum8.webp",
      link: "https://corum8.com/",
    },
           {
      alt: "ExpoTobi",
      src: "/images/mediapartnerlogo/expotobi.webp",
      link: "https://expotobi.com/",
    },
           {
      alt: "tech-token",
      src: "/images/mediapartnerlogo/tech-token.webp",
      link: "https://techtokens.in/",
    },
           {
      alt: "Coinlytx",
      src: "/images/mediapartnerlogo/coinlyx.webp",
      link: "https://coinlytx.com/",
    },
           {
      alt: "Coinaute",
      src: "/images/mediapartnerlogo/coinaute.webp",
      link: "https://coinaute.com/",
    },
     {
      alt: "VitaminAi",
      src: "/images/mediapartnerlogo/vitaminai.webp",
      link: "https://vitaminai.online/",
    },
     {
      alt: "logo-coinkimona-logo",
      src: "/images/mediapartnerlogo/logo-coinkimona-logo.webp",
      link: "https://coinkimona.com/",
    },
     {
      alt: "lixwe",
      src: "/images/mediapartnerlogo/lixwe.webp",
      link: "https://lixwe.com/",
    },
     {
      alt: "Altwow",
      src: "/images/mediapartnerlogo/altwow.webp",
      link: "https://altwow.com/",
    },
      {
      alt: "propfirm-lion",
      src: "/images/mediapartnerlogo/propfirm-lion.webp",
      link: "https://propfirmlion.com/",
    },
      {
      alt: "Expotobi",
      src: "/images/mediapartnerlogo/expotobi.webp",
      link: "https://expotobi.in/",
    },
      {
      alt: "Coinhohe",
      src: "/images/mediapartnerlogo/coinhohe.webp",
      link: "https://coinhohe.com/",
    },

    {
      alt: "market-period",
      src: "/images/mediapartnerlogo/markert-periodical.webp",
      link: "https://themarketperiodical.com/",
    },

     {
      alt: "thecoinrepublic",
      src: "/images/mediapartnerlogo/the-coin-republic-logo.webp",
      link: "https://www.thecoinrepublic.com/",
    },

    {
      alt: "thecioreview",
      src: "/images/mediapartnerlogo/cio-review .webp",
      link: "https://cioreview.com/",
    },

    {
      alt: "dubai-global-news",
      src: "/images/mediapartnerlogo/dubai-global-news.webp",
      link: "https://www.dubaiglobalnews.com/",
    },
    {
      src: '/images/mediapartnerlogo/cryptonewss.webp',
      alt: 'CryptosNewss',
      link: 'https://cryptosnewss.com/',
    },
    {
      src: '/images/mediapartnerlogo/cryptonews.webp',
      alt: 'CryptoNews',  
      link: 'https://cryptonews.com/',
    },
    
    {
      src: '/images/mediapartnerlogo/aff.webp',
      alt: 'AFFMaven', 
      link: 'https://affmaven.com/',
    },
    
    {
      src: '/images/mediapartnerlogo/indnewswire.webp',
      alt: 'IndNewsWire',
      link: 'https://indnewswire.com/',
    },
    {
      src: '/images/mediapartnerlogo/web3africawhite.webp',
      alt: 'web3africawhite',
      link: 'https://web3africa.tech/',
    },
     {
      src: '/images/mediapartnerlogo/blockchainreporter.webp',
      alt: 'blockchainreporter',
      link: 'https://blockchainreporter.net/',
    },
    {src: '/images/mediapartnerlogo/game-3s-white.webp', atl: 'game-3s-white', link: 'https://www.games.gg/',},
    {src: '/images/mediapartnerlogo/invest24-logo.webp', atl: 'invest24-logo', link: 'https://www.invest24.uz/',},
    {src: '/images/mediapartnerlogo/blockchain-texno-white.webp', atl: 'blockchain-texno', link: 'https://www.blockchaintexno.uz/',},
    {src: '/images/mediapartnerlogo/tredu-logopr.svg', atl: 'tredu-logo', link: 'https://www.tredu.com/',},
*/
    {
    src: '/images/mediapartnerlogo/igaming.webp',
    alt: 'igaming',
    link: 'https://www.igamingcafe.com/',
  },
  {
    src: '/images/mediapartnerlogo/oursn-logo.webp',
    alt: 'oursn-logo',
    link: 'https://oursn.net/',
  },
  {
    src: '/images/mediapartnerlogo/prmenia-logo.webp',
    alt: 'prmenia-logo',
    link: 'http://pr-mena.com/',
  },
  {
    src: '/images/mediapartnerlogo/the-betting-coach-logo.webp',
    alt: 'the-betting-coach-logo',
    link: 'https://www.thebettingcoach.com/',
  },
  {
    src: '/images/mediapartnerlogo/jamma-logo.webp',
    alt: 'jamma-logo',
    link: 'https://www.jamma.it/tag/jamma-europe',
  },
  {
    src: '/images/mediapartnerlogo/angelos-logo.webp',
    alt: 'angelos-logo',
    link: 'https://angelos-consulting.com/',
  },
  {
    src: '/images/mediapartnerlogo/chimeraspin-logo.webp',
    alt: 'chimeraspin-logo',
    link: 'https://www.chimeraspin.com/casino-games',
  },
  {
    src: '/images/mediapartnerlogo/gamingworld-logo.webp',
    alt: 'gamingworld-logo',
    link: 'https://www.gamingworld-directory.com/',
  },
  {
    src: '/images/mediapartnerlogo/gnb-logo.webp',
    alt: 'gamingnewsbyte',
    link: 'https://gamingnewsbyte.com/',
  },
  {
    src: '/images/mediapartnerlogo/bftimes.webp',
    alt: 'bfm-times',
    link: 'https://bfmtimes.com/',
  },
  {
    src: '/images/mediapartnerlogo/knup-logo-horizontal.webp',
    alt: 'knup',
    link: 'https://knup.com/',
  },
  {
    src: '/images/mediapartnerlogo/oyun-logo.webp',
    alt: 'oyun-gunlugu',
    link: 'https://www.oyungunlugu.com/',
  },
  {
    src: '/images/mediapartnerlogo/business-of-igaming-logo-retina.webp',
    alt: 'business-of-igaming',
    link: 'https://www.businessofigaming.com/',
  },
  {
    src: '/images/mediapartnerlogo/gamedev-street.webp',
    alt: 'gamedev-street',
    link: 'https://taplink.cc/gamedev_street',
  },
  {
      alt: "Smart-Money-Match",
      src: "/images/mediapartnerlogo/smart-money-match.webp",
      link: "https://www.smartmoneymatch.com/help/media-partnerships",
    },
  {
    alt: "Transport-Stake",
      src: "/images/mediapartnerlogo/transport-stake-logo.webp",
      link: "https://www.transportstake.com/",
  },
  {
      alt: "Publicity-Marketplace",
      src: "/images/mediapartnerlogo/publicity-marketplace.webp",
      link: "https://www.publicitymarketplace.com/",
    },
  {
    src: '/images/mediapartnerlogo/functionalsourcing.webp',
    alt: 'functionalsourcing',
    link: 'https://www.functionalsourcing.com/',
  },
  {
      alt: "Education-Stake",
      src: "/images/mediapartnerlogo/education-stake-logo.webp",
      link: "https://www.educationstake.com/",
    },
  {
      alt: "MatchSDG",
      src: "/images/mediapartnerlogo/match-sdg-logo.webp",
      link: "https://www.matchsdg.com/",
    },
  ];

  return (
    <section data-component-id="src/app/PartnersSection.tsx:480:4" data-component-path="src/app/PartnersSection.tsx" data-component-line="480" data-component-end-line="548" data-component-file="PartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20py-10%20bg-primary-background%22%7D" id="partners" className="w-full py-10 bg-primary-background">

      {/* partnersLogo */}
      <div data-component-id="src/app/PartnersSection.tsx:483:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="483" data-component-end-line="512" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1342px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-[1342px] mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Heading */}
          <h2 data-component-id="src/app/PartnersSection.tsx:485:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="485" data-component-end-line="487" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-Gotham%20text-center%20mb-20%20font-bold%20text-%5B20px%5D%20sm%3Atext-%5B26px%5D%20md%3Atext-%5B32px%5D%20leading-%5B24px%5D%20sm%3Aleading-%5B31px%5D%20md%3Aleading-%5B39px%5D%20text-text-primary%22%2C%22textContent%22%3A%22Past%20Partners%22%7D" className="font-Gotham text-center mb-20 font-bold text-[20px] sm:text-[26px] md:text-[32px] leading-[24px] sm:leading-[31px] md:leading-[39px] text-text-primary">
           Past Partners              
          </h2>

          {/* Logos Grid */}
          <div data-component-id="src/app/PartnersSection.tsx:490:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="490" data-component-end-line="511" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20items-center%20gap-4%20sm%3Agap-6%22%7D" className="flex justify-center items-center gap-4 sm:gap-6">
            {Partners.map((partner, index) => (
              <Link data-component-id="src/app/PartnersSection.tsx:492:14" data-component-path="src/app/PartnersSection.tsx" data-component-line="492" data-component-end-line="509" data-component-file="PartnersSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22bg-%5B%233c3c3c%5D%20rounded-%5B14px%5D%20flex%20justify-center%20items-center%22%7D"
                key={index}
                href={partner.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="bg-[#3c3c3c] rounded-[14px] flex justify-center items-center"
              >
                <Image data-component-id="src/app/PartnersSection.tsx:499:16" data-component-path="src/app/PartnersSection.tsx" data-component-line="499" data-component-end-line="508" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20p-2%20rounded-md%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20w-%5B120px%5D%20h-%5B60px%5D%20%20%20%20%20%20%20%20%2F*%20mobile%20default%20*%2F%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20md%3Aw-%5B180px%5D%20md%3Ah-%5B100px%5D%20%2F*%20desktop%20*%2F%22%7D"
                  src={partner.src}
                  alt={partner.alt}
                  width={150}
                  height={80}
                  unoptimized
                  className="object-contain p-2 rounded-md 
                            w-[120px] h-[60px]        /* mobile default */
                            md:w-[180px] md:h-[100px] /* desktop */"
                />
              </Link>
            ))}
          </div>
        </div>


      {/* Media Partners  */}
      <div data-component-id="src/app/PartnersSection.tsx:516:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="516" data-component-end-line="547" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1342px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-[1342px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Heading */}
         <h2 data-component-id="src/app/PartnersSection.tsx:518:9" data-component-path="src/app/PartnersSection.tsx" data-component-line="518" data-component-end-line="520" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-Gotham%20text-center%20py-20%20font-bold%20text-%5B20px%5D%20sm%3Atext-%5B26px%5D%20md%3Atext-%5B32px%5D%20leading-%5B24px%5D%20sm%3Aleading-%5B31px%5D%20md%3Aleading-%5B39px%5D%20text-text-primary%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="font-Gotham text-center py-20 font-bold text-[20px] sm:text-[26px] md:text-[32px] leading-[24px] sm:leading-[31px] md:leading-[39px] text-text-primary">
         Media Partners              
        </h2>


        {/* Logos Grid */}
       <div data-component-id="src/app/PartnersSection.tsx:524:7" data-component-path="src/app/PartnersSection.tsx" data-component-line="524" data-component-end-line="546" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-%5Brepeat(auto-fit%2Cminmax(150px%2C1fr))%5D%20gap-6%20sm%3Agap-8%20justify-items-center%20items-center%22%7D" className="grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-6 sm:gap-8 justify-items-center items-center">
        {mediaPartners.map((partner, index) => (
        <a data-component-id="src/app/PartnersSection.tsx:526:8" data-component-path="src/app/PartnersSection.tsx" data-component-line="526" data-component-end-line="544" data-component-file="PartnersSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22bg-%5B%23fff%5D%20rounded-%5B14px%5D%20flex%20justify-center%20items-center%20w-full%22%7D"
          key={index}
          href={partner.link}
          // target="_blank"
          // rel={index === 8 ? "noopener noreferrer" : "noopener noreferrer nofollow"}
          target="_blank" rel="nofollow noopener noreferrer"
          className="bg-[#fff] rounded-[14px] flex justify-center items-center w-full"
        >
          <Image data-component-id="src/app/PartnersSection.tsx:534:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="534" data-component-end-line="543" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20p-2%20rounded-md%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20w-%5B120px%5D%20h-%5B60px%5D%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20md%3Aw-%5B180px%5D%20md%3Ah-%5B100px%5D%22%7D"
            src={partner.src}
            alt={partner.alt}
            width={150}
            height={80}
            unoptimized
            className="object-contain p-2 rounded-md 
                      w-[120px] h-[60px]
                      md:w-[180px] md:h-[100px]"
          />
        </a>
      ))}   
   </div>
      </div>
    </section>
  );
};

export default PartnersSection;

